import { useState } from 'react';
import { ButtonGroup, IconButton, Menu, MenuItem } from '@mui/material';
import { isBottomFromTenantAdmin } from 'components/helpers/IsBottomFromTenantAdmin';
import SettingsIcon from '@mui/icons-material/Settings';
import MiscDialogForm from 'components/inventory/Warehouses/MiscProductWarehouseForm';

type ActionMenuCellProps = {
  row: any;
  onManagePrices: (product: string) => void;
  t: (key: string) => string;
  refresh?: any;
};

export const ActionMenuCell = ({ row, onManagePrices, t, refresh }: ActionMenuCellProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [editOpen, setEditOpen] = useState(false);

  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleManagePrices = () => {
    handleMenuClose();
    onManagePrices(row.product);
  };

  const handleEditOpen = () => {
    handleMenuClose();
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
  };

  return (
    <>
      <ButtonGroup variant="outlined" size="small">
        <IconButton onClick={handleMenuOpen}>
          <SettingsIcon />
        </IconButton>
      </ButtonGroup>
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
        {onManagePrices && (
          <MenuItem onClick={handleManagePrices}>{t('global.manage_prices')}</MenuItem>
        )}
        {isBottomFromTenantAdmin() && (
          <MenuItem onClick={handleEditOpen}>{t('global.edit')}</MenuItem>
        )}
      </Menu>
      {editOpen && (
        <MiscDialogForm open={editOpen} onClose={handleEditClose} row={row} refresh={refresh} />
      )}
    </>
  );
};
